import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AuthWebService } from "app/services/authweb.service";
import { CarrierService } from "app/services/carrier.service";
import { UtilityServiceService } from "app/services/utility-service.service";
import { AdminMonthlyComplianceListFilterConfig } from "app/shared/filter/filter.constant";
import { ToastrService } from "ngx-toastr";
import { ToastNotificationService } from "app/shared/toast-notification/toast-notification.service";
import { MonthlyComplianceService } from 'app/services/monthly-compliance.service';
import { AnnualComplianceService } from 'app/annual-compliance/service/annual-compliance.service';
import * as moment from 'moment';
import { StatusService } from 'app/services/status.service';
import { FilterService } from 'app/shared/filter/filter.service';
import { ApplicationService } from 'app/services/application.service';
import { environment } from "../../../environments/environment";

@Component({
  selector: 'app-admin-monthly-compliance',
  templateUrl: './admin-monthly-compliance.component.html',
  styleUrls: ['./admin-monthly-compliance.component.scss']
})
export class AdminMonthlyComplianceComponent implements OnInit {
  @Input("ctrlData") ctrlData: any;
  permits: any = [];

  permitsOverdue: any = [];
  permitsDueOneMonth: any = [];

  permitsTrackApplication: any = [];
  statuses: any = [];
  flags = {
    flagAN: 1,
    flagNM: 1,
    flagLU: 1,
    flagCT: 1,
    flagAP: 1,
    flagPN: 1,
    flagPT: 1,
    flagST: 1,
    flagDS: 1,
    flagAI: 1,
  };
  ranks = {
    flagAN: 1,
    flagNM: 2,
    flagLU: 3,
    flagCT: 4,
    flagAP: 5,
    flagPN: 6,
    flagPT: 7,
    flagST: 8,
    flagDS: 9,
    flagAI: 10,
  };
  sortLabels = {
    flagAN: "AccountNumber",
    flagNM: "Name",
    flagLU: "LeadUser",
    flagCT: "CarrierType",
    flagAP: "ApplicationNumber",
    flagPN: "PermitNumber",
    flagPT: "PermitType",
    flagST: "Status",
    flagDS: "DateSubmitted",
    flagAI: "AccountId",
  };
  direction: boolean = false;
  criteria = "DateSubmitted";
  rankCtrl: number = 1;
  isLoading: Boolean = false;
  message: string = "Loading  permit applications, please wait...";
  statuses1: any = [];
  keyword: any = {};
  currentPage = 1;
  isEmpty: boolean = false;
  pageSize: number = 10;
  PermitStatus2: number;
  PermitStatus4: number;
  PermitStatus6: number;
  PermitStatus8: number;
  count: number = 0;
  disabled = false;
  ShowFilter = false;
  limitSelection = false;
  selectedItems: any = [];
  dropdownSettings: any = {};

  isDef: boolean = true;
  currentUserName: string = "";
  filterStatus: any;
  selectedPermit: any = null;
  selectedIndex: number;
  showActions: boolean = false;
  //Filters
  carrierNumber: string;
  carrierId: string;
  carrierName: string;
  permitNumber: String;
  companyRegNumber: string;
  first_Name: string;
  surname: string;
  vehicle_Registration: string;
  application_Number: string;
  months: string[];
  IsSearching: boolean = false;
  status: string = "";
  user: any = {};
  filterConfig = AdminMonthlyComplianceListFilterConfig;
  isFilteredDataEmpty: boolean = false;
  groupedPermits: any;
  isAppliedFilter: boolean = false;


  constructor(
    private authWebService: AuthWebService,
    private _router: Router,
    private _toaster: ToastrService,
    private toastService: ToastNotificationService,
    private monthlyComplianceService: AnnualComplianceService,
    private monthlyCompliance: MonthlyComplianceService,
    private _activatedRoute: ActivatedRoute,
    private _carrier: CarrierService,
    public utility: UtilityServiceService,
    private msg: ToastrService,
    private statusService: StatusService,
    private carrierService: CarrierService,
    private applicationService: ApplicationService,
    private router: Router,
    private route: ActivatedRoute,
    private filterCarrier: FilterService
  ) {
    
    this.user = this.authWebService.userData
      ? this.authWebService.userData.User
      : null;
  }

  ngOnInit(): void {
    this.utility.page = 1;
   // this.getList();
    const startingDate = new Date();
    this.months = this.generateMonthHeadings(6, startingDate);
    this.route.queryParams.subscribe((queryParams) => {
      if (Object.keys(queryParams).length > 0) {
        this.applyFilter(queryParams);
      } else {
        this.getList();
      }
    });
  
  }




  getList() {
    this.initKeyword();
    this.isLoading = true;
    let url = `${this.currentPage}/${this.pageSize}`;
    let body = this.keyword;
    this.monthlyComplianceService.searchPermits(url, body).subscribe(
      (result: any) => {
        console.log('result',result)
        this.permits = result?.Permits;
        this.count = result.count;
          this.utility.onSort(1);
   //     
        this.isFilteredDataEmpty = false;
        this.isLoading = false;
       // if (result.Count == 0) this.isFilteredDataEmpty = true;
      },
      (error) => {
        this.permits = [];
        this.isLoading = false;
        this.isFilteredDataEmpty = true;
      }
    );
  }
  onReset() {
    const startingDate = new Date();
    this.months = this.generateMonthHeadings(6, startingDate);
    this.pageSize = 10;
    this.currentPage = 1;
    this.getList();
  }

  applyFilter(filters) {
    if (!filters) {
      this.keyword = {};
      this.isFilteredDataEmpty = false;
      
      const currentDate = new Date();
      currentDate.setMonth(currentDate.getMonth() - 6);
      const formattedStartMonth = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1).toString().padStart(2, '0')}`;
      this.keyword.StartingMonth = formattedStartMonth;
  
      this.getList();
    } else {
      this.keyword.StartingMonth = ""; // Reset the starting month
  
      if (filters.StartingMonth) {
        const parsedDate = new Date(filters.StartingMonth);
        const formattedStartMonth = `${parsedDate.getFullYear()}${(parsedDate.getMonth() + 1).toString().padStart(2, '0')}`;
        this.keyword.StartingMonth = formattedStartMonth;
        const startingDate = new Date(filters.StartingMonth);
      this.months = this.generateMonthHeadings(6, startingDate);
      }  
    this.selectedItems = filters?.Statuses;
    this.keyword.AccountNumber = filters?.AccountNumber
        ? filters.AccountNumber
        : "";
      this.keyword.AccountType =
        filters?.AccountType
          ? filters?.AccountType
          : "";
          this.keyword.Suffix =
          filters?.Suffix
            ? filters?.Suffix
            : "";
            (this.keyword.Statuses = this.selectedItems
              ? this.selectedItems.map((status) => {
                  return status.id;
                })
              : []);
              this.router.navigate([], {
                relativeTo: this.route,
                queryParams: filters,
                queryParamsHandling: 'merge', // Preserve existing query parameters
              });
            
      if (filters) {
      //  this.months = this.generateMonthHeadings(6, new Date(filters.StartingMonth));
      
      this.getFilterResponse();
      } else {
      
        this.getList();
      }
    
  }}
  
  getFilterResponse() {
    this.isLoading = true;
    this.isAppliedFilter=true;
    let url = `${this.currentPage}/${this.pageSize}`;
    let body = this.keyword;
    this.monthlyComplianceService.searchPermits(url, body).subscribe(
      (result: any) => {
        console.log('result',result)
        this.permits = result?.Permits;
        this.count = result?.countGroupedPermits;
        this.isFilteredDataEmpty = false;
        this.utility.onSort(1);
        this.isLoading = false;
        if (result.count == 0) this.isFilteredDataEmpty = true;
      },
      (error) => {
        this.permits = [];
        this.isLoading = false;
        this.isFilteredDataEmpty = true;
      }
    );
  }

  getFilterResponse2() {
    this.isLoading = true;
    
    let url = `${this.currentPage}/${this.pageSize}`;
    let body = this.keyword;
    this.monthlyComplianceService.searchPermits(url, body).subscribe(
      (result: any) => {
        console.log('result',result)
        this.permits = result?.Permits;
        this.count = result?.countGroupedPermits;
        this.isFilteredDataEmpty = false;
        this.utility.onSort(1);
        this.isLoading = false;
        if (result.count == 0) this.isFilteredDataEmpty = true;
      },
      (error) => {
        this.permits = [];
        this.isLoading = false;
        this.isFilteredDataEmpty = true;
      }
    );
  }

  onSearch() {
    this.isLoading = true;
    let url = `${this.currentPage}/${this.pageSize}`;
    let body = this.keyword;
    this.monthlyComplianceService.searchPermits(url, body).subscribe(
      (result: any) => {
        this.isAppliedFilter= true ;
        this.permits = result.Permits;
        this.count = result.count;
        this.isFilteredDataEmpty = false;
        this.isLoading = false;
        if (result.count == 0) this.isFilteredDataEmpty = true;
      },
      (error) => {
        this.permits = [];
        this.isLoading = false;
        this.isFilteredDataEmpty = true;
      }
    );
  }

 

  onNextOrPrevious(page: number = 1) {
    this.currentPage = page;
    const startingDate = new Date();
    this.message = "Loading  permits, please wait...";
    this.months = this.generateMonthHeadings(6, startingDate);
    if (Object.keys(this.keyword).length > 0) {
      this.getFilterResponse();
    } else {
      this.getList();
       this.utility.page = page;
    }
    this.utility.page = page;
    return page;
  }

              /////           
  onNext(page: number = 1) {
    this.currentPage = page;
    const startingDate = new Date();
    this.message = "Loading  permits, please wait...";
    this.months = this.generateMonthHeadings(6, startingDate);
    if (Object.keys(this.keyword).length > 0) {
      this.getFilterResponse2();
    } else {
      this.getList();
       this.utility.page = page;
    }
    this.utility.page = page;
    return page;
  }

  getTotalTripsForMonth(item, month) {
    let total = 0;
  
    if (item && item.MonthlyData) {
      // Filter MonthlyData for the specified month
      const monthlyDataForMonth = item.MonthlyData.find(data => data.yyyy_mm === month);
  
      // If data is found, sum up NumPermits
      if (monthlyDataForMonth) {
        total = monthlyDataForMonth.NumTrips;
      }
    }
  
    return total;
  }
  
  
  onChange(event) {
    this.currentPage = 1;
    this.pageSize = event;
    const startingDate = new Date();
    this.months = this.generateMonthHeadings(6, startingDate);
    if (Object.keys(this.keyword).length > 0) {
      this.getFilterResponse();
    } else {
      this.getList();
    }
  }

  initKeyword = () => {
    this.keyword = {
      Suffix: "",
      AccountNumber: "",
      AccountType: "",
      StartingMonth: "",
      Statuses: [],
    };}

    navigate(carrierId)
{
 // this._router.navigate(['carrier/monthly-returns', carrierId, permitId, complianceId]);
  this._router.navigate(['monthly-compliance/list/'+ carrierId]);
}
  onNextOrPrevious2(page: number = 1) {
    this.message = "Loading  permits, please wait...";
    const startingDate = new Date();
    this.months = this.generateMonthHeadings(6, startingDate);
    this.getList();
    this.currentPage = page;
    return page;
  }

  
    
  private generateMonthHeadings(numMonths: number, startingDate: Date): string[] {
    const headings: string[] = [];
    const monthNames = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];
    
    for (let i = 0; i < numMonths; i++) {
      const currentDate = new Date(startingDate.getFullYear(), startingDate.getMonth() - i, 1);
      const month = currentDate.getMonth();
      const year = currentDate.getFullYear();
      headings.unshift(`${monthNames[month]} ${year}`);
    }
    
    return headings;
  }
  hasMonthlyData(permit: any, month: string): boolean {
    return permit.MonthlyData.some(
      monthlyData => this.getMonthFromDate(monthlyData.yyyy_mm) === month
    );
  }

  getMonthlyTrips(permit: any, month: string): string {
    const monthlyData = permit.MonthlyData && permit.MonthlyData.find(
      monthlyData => this.getMonthFromDate(monthlyData.yyyy_mm) === month
    );
    return monthlyData ? monthlyData.NumTrips.toString() : '';
  }
  

  getMonthFromDate(yyyy_mm: number): string {
    const year = Math.floor(yyyy_mm / 100);
    const month = yyyy_mm % 100;
    const date = new Date(year, month - 1, 1); // Subtract 1 from month since JavaScript uses 0-based indexing for months
    const formattedMonth = date.toLocaleString('default', { month: 'long', year: 'numeric' });
    return formattedMonth;
  }


  
  

}
